<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">HTMLページ管理</h2>
        <permission-guard situation="html_page_management">
          <v-btn
            color="primary"
            dark
            tile
            class="ma-2"
            to="/admin/settings/html_pages/new"
          >
            新規作成
          </v-btn>

          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">id</th>
                  <th class="text-center">ページ名</th>
                  <th class="text-center">公開URL</th>
                  <th class="text-center">適用中のバージョン</th>
                  <th />
                  <th />
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="htmlPage in htmlPages" :key="htmlPage.id">
                  <td class="text-center">
                    {{ htmlPage.id }}
                  </td>
                  <td class="text-center">
                    {{ htmlPage.title }}
                  </td>
                  <td class="text-center">
                    <a :href="htmlPagePublicUrl(htmlPage)" target="_blank">
                      {{ htmlPagePublicUrl(htmlPage) }}
                    </a>
                  </td>
                  <td class="text-center">{{ htmlPage.applyVersion }}</td>
                  <td class="text-center">
                    <template v-if="htmlPage.published">
                      <v-chip
                        class="ma-2 font-weight-bold"
                        x-small
                        label
                        color="success"
                      >
                        公開
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip
                        class="ma-2 font-weight-bold"
                        x-small
                        label
                        color="error"
                      >
                        非公開
                      </v-chip>
                    </template>
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      small
                      color="primary"
                      :to="basicEditUrl(htmlPage)"
                    >
                      <v-icon left small> mdi-pencil</v-icon>
                      基本設定編集
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      small
                      color="primary"
                      :to="versionEditUrl(htmlPage)"
                    >
                      <v-icon left small> mdi-pencil</v-icon>
                      バージョン編集
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      small
                      color="error"
                      @click="destroy(htmlPage)"
                    >
                      <v-icon left small> mdi-delete</v-icon>
                      削除
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <infinite-loading
            spinner="spiral"
            class="mt-4"
            :identifier="infiniteId"
            @infinite="infiniteHandler"
          >
            <template v-slot:no-more>
              <v-chip label outlined> 全て表示されました。</v-chip>
            </template>
            <template v-slot:no-results>
              <v-chip label outlined> 表示できるものがありません。</v-chip>
            </template>
          </infinite-loading>
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import { deserialize } from 'deserialize-json-api'
import InfiniteLoading from 'vue-infinite-loading'
import { mapState } from 'vuex'
import headUtilsMixin from '@/mixins/head_utils'
import urlUtils from '@/mixins/url_utils'

export default {
  name: 'HtmlPages',
  components: {
    PermissionGuard,
    InfiniteLoading
  },
  mixins: [headUtilsMixin, urlUtils],
  data: () => {
    return {
      pageTitle: 'HTMLページ一覧',
      page: 1,
      htmlPages: [],
      loading: true,
      infiniteId: +new Date()
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    })
  },
  methods: {
    infiniteHandler ($state) {
      axios
        .get('/api/html_pages', {
          params: {
            page: this.page
          }
        })
        .then(
          ({ data }) => {
            const fetchedHtmlPages = deserialize(data).data

            if (fetchedHtmlPages.length > 0) {
              this.page++
              this.htmlPages = this.htmlPages.concat(fetchedHtmlPages)
              $state.loaded()
            } else {
              $state.complete()
            }
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    destroy (htmlPage) {
      if (confirm('本当に削除しますか？')) {
        this.$store.dispatch('LoaderStore/displayLoader')
        axios
          .delete(`/api/html_pages/${htmlPage.id}`)
          .then(
            () => {
              const index = this.htmlPages.findIndex(
                (v) => v.id === htmlPage.id
              )
              this.htmlPages.splice(index, 1)
              const payload = {
                status: 200,
                message: 'HTMLページを削除しました'
              }
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
            },
            (error) => {
              const payload = {
                status: error.response.status,
                message: error.response.data.errors.toString()
              }
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
            }
          )
          .finally(() => {
            this.$store.dispatch('LoaderStore/hideLoader')
          })
      }
    },
    basicEditUrl (htmlPage) {
      return '/admin/settings/html_pages/' + htmlPage.id + '/basic_edit'
    },
    versionEditUrl (htmlPage) {
      return '/admin/settings/html_pages/' + htmlPage.id + '/edit'
    }
  }
}
</script>
<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
